<!--
  TODO: After launch check the styling and layout of this matrix element.
  Consider where it is used and what exceptions should be kept in mind.
  Classes were copied from other components without any reason.
  It is also styled too poorly.
-->
<template>
  <section class="container z-grid v-page-section-container-padding mb-8 md:mb-12">
    <div class="relative z-10 z-grid__cols z-grid__content py-6 bg-white rounded-3xl">
      <div>{{ t_('description') }}</div>
      <div v-show="successMessages.length">
        <p v-for="(message, index) in successMessages" :key="index" class="font-bold mt-5">{{ message }}</p>
      </div>
      <div v-show="!tixUser" class="font-bold mt-5">{{ t_('no-tix-user-found') }}</div>
      <div v-show="tixUser && !successMessages.length" class="mt-5">
        <FormKit v-slot="{ state: { loading } }" type="form" :actions="false" @submit="submitVipCardHandler">
          <FormKit type="text" name="number" :placeholder="t_('number-placeholder')" :help="t_('number-help')" validation="required|number" inputmode="numeric" pattern="[0-9]*" />

          <FormKit type="submit" :disabled="loading">
            <AtomIcon v-show="loading" icon="app-loader" class="mr-2 w-5 h-5 text-white" />
            {{ t_('submit-label') }}
          </FormKit>
        </FormKit>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { FormKitNode } from '@formkit/core'
defineProps({
  label: { type: String, required: false, default: undefined },
  description: { type: String, required: false, default: undefined },
  successText: { type: String, required: false, default: undefined },
  invalidText: { type: String, required: false, default: undefined },
})

const config = useRuntimeConfig()
const tixStore = useTixStore()
const { tixUser, tixUpdate } = setupTix()
const { t_ } = setupTranslationPrefixer('MatrixVriendenLoterijVipCard')
const successMessages = ref<string[]>([])

async function submitVipCardHandler(data: CmsData, node: FormKitNode) {
  // Reload the Tix session to make sure we have the latest user data.
  await tixStore
    .call({ call: 'GetSession' })
    .then((data) => {
      tixUpdate(data)
    })
    .catch((e) => {
      console.error('Error calling GetSession', e)
    })

  // Clear errors and successes before saving
  node.clearErrors()
  successMessages.value = []

  // A Tix user is required, because we will immediately add a tag when the VIP is valid
  if (!tixUser.value) {
    node.setErrors([t_('no-tix-user-found')])
    return
  }

  const response = await fetch(`${config.public.bridgeSiteUrl}/api/vip-card/${data.number}/${tixUser.value.id}/validate?hash=${tixUser.value.hash}`, {
    headers: {
      Accept: 'application/json',
    },
  })

  if ((await response.json())?.success) {
    successMessages.value = [t_('generic-success')]
  } else {
    node.setErrors([t_('generic-error')])
  }
}
</script>
